import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recovery-access',
  templateUrl: './recovery-access.page.html',
  styleUrls: ['./recovery-access.page.scss'],
  standalone: false
})
export class RecoveryAccessPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
